import * as THREE from "three"
import type { ScenePrimitiveShape } from "@/lib/location-scene-3d/scene-state"

const MESH_ROUGHNESS = 0.55
const MESH_METALNESS = 0.08

/** Same geometries as scene props and primitives. Mesh is centered on its origin. */
export function createPrimitiveMesh(
  shape: ScenePrimitiveShape,
  size: [number, number, number],
  color: string | number,
): THREE.Mesh {
  const [sx, sy, sz] = size
  let geometry: THREE.BufferGeometry
  switch (shape) {
    case "sphere":
      geometry = new THREE.SphereGeometry(Math.max(sx, sy, sz) / 2, 64, 32)
      break
    case "cylinder":
      geometry = new THREE.CylinderGeometry(sx / 2, sx / 2, sy, 20)
      break
    case "cone":
      geometry = new THREE.ConeGeometry(sx / 2, sy, 20)
      break
    case "plane":
      geometry = new THREE.BoxGeometry(sx, Math.max(sy, 0.04), sz)
      break
    default:
      geometry = new THREE.BoxGeometry(sx, sy, sz)
  }
  const mesh = new THREE.Mesh(
    geometry,
    new THREE.MeshStandardMaterial({
      color,
      roughness: MESH_ROUGHNESS,
      metalness: MESH_METALNESS,
    }),
  )
  mesh.castShadow = true
  mesh.receiveShadow = true
  return mesh
}
